import { combineReducers } from "redux";

import contactReducer from "./contactReducer";
import messageReducer from "./messageReducer";
import notificationReducer from "./notificationReducer";
import custommessageReducer from "./custommessageReducer";
import menuReducer from "./menuReducer";
import settingsReducer from "./settingsReducer";
import authReducer from "./authReducer";
import voicemailReducer from "./voicemailReducer";
import preferencesReducer from "./preferencesReducer";
import tagReducer from "./tagReducer";

const allReducers = combineReducers({
  contacts: contactReducer,
  messages: messageReducer,
  notifications: notificationReducer,
  customMessages: custommessageReducer,
  menu: menuReducer,
  settings: settingsReducer,
  authUser: authReducer,
  voicemails: voicemailReducer,
  preferences: preferencesReducer,
  tags: tagReducer,
});

export default allReducers;
